/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergenzaAssistitoUpdateDTO
 */
export interface EmergenzaAssistitoUpdateDTO {
    /**
     * 
     * @type {boolean}
     * @memberof EmergenzaAssistitoUpdateDTO
     */
    assistenza?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaAssistitoUpdateDTO
     */
    puntoDiRaccoltaId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmergenzaAssistitoUpdateDTO
     */
    prelievo?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaAssistitoUpdateDTO
     */
    altroLuogo?: string;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaAssistitoUpdateDTO
     */
    noteRifiuto?: string;
}

/**
 * Check if a given object implements the EmergenzaAssistitoUpdateDTO interface.
 */
export function instanceOfEmergenzaAssistitoUpdateDTO(value: object): value is EmergenzaAssistitoUpdateDTO {
    return true;
}

export function EmergenzaAssistitoUpdateDTOFromJSON(json: any): EmergenzaAssistitoUpdateDTO {
    return EmergenzaAssistitoUpdateDTOFromJSONTyped(json, false);
}

export function EmergenzaAssistitoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergenzaAssistitoUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'assistenza': json['assistenza'] == null ? undefined : json['assistenza'],
        'puntoDiRaccoltaId': json['puntoDiRaccoltaId'] == null ? undefined : json['puntoDiRaccoltaId'],
        'prelievo': json['prelievo'] == null ? undefined : json['prelievo'],
        'altroLuogo': json['altroLuogo'] == null ? undefined : json['altroLuogo'],
        'noteRifiuto': json['noteRifiuto'] == null ? undefined : json['noteRifiuto'],
    };
}

export function EmergenzaAssistitoUpdateDTOToJSON(value?: EmergenzaAssistitoUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'assistenza': value['assistenza'],
        'puntoDiRaccoltaId': value['puntoDiRaccoltaId'],
        'prelievo': value['prelievo'],
        'altroLuogo': value['altroLuogo'],
        'noteRifiuto': value['noteRifiuto'],
    };
}

